import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ customerReference3Error: string }>;

export const DispatchcustomerReference3Error: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/CustomerReference3Error",
        customerReference3Error: props.parameter.customerReference3Error,
    });
};

export const chain = [DispatchcustomerReference3Error];

const setCustomerReference3Error = createHandlerChainRunner(chain, "customerReference3Error");
export default setCustomerReference3Error;
